import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import ConnectedFormControl from '../FormControl/FormControl.js';

const PostalCode = (_param)=> {
    var { label , errorMessage  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "label",
        "errorMessage"
    ]);
    return React.createElement(ConnectedFormControl, swcHelpers.extends({}, ConnectedFormControl.defaultProps, {
        id: "postalCode",
        "data-t": "postal-code",
        label: label,
        errorMessage: errorMessage
    }, rest));
};

export { PostalCode as default };
//# sourceMappingURL=PostalCode.js.map
